export const checkIsClientInfoFullyFilled = (info: unknown) => {
  if (!info) return false;
  const values = Object.values(info);
  const filledValues = values.filter(
    // Пропускаем "0" как валидное значение
    (item) => item !== undefined && item !== null && item !== ''
  );
  return filledValues.length === values.length;
};
